import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Paper,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";

import { ReactComponent as MaryIcon } from "../assets/Frame_small.svg";
import { ReactComponent as WaveIcon } from "../assets/wave.svg";
import { ReactComponent as MicIcon } from "../assets/mic.svg";
import { ReactComponent as SubmitIcon } from "../assets/submit.svg";
import { ReactComponent as HomeIcon } from "../assets/home.svg";
import { ReactComponent as ProfileIcon } from "../assets/profile.svg";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ReactComponent as MicOnIcon } from "../assets/voice-search.svg";
import { ReactComponent as CloseIcon } from "../assets/close.svg";
import { ReactComponent as PencilIcon } from "../assets/PencilSimpleLine.svg";
import { ReactComponent as TrashIcon } from "../assets/TrashSimple.svg";
import { styled } from "@mui/system";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import parse from "html-react-parser"; // To render HTML responses
const MessagesContainer = styled(Box)({
  flex: 1,
  padding: "10px",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});
const MessageBubble = styled(Paper)(({ isUser }) => ({
  padding: "10px 15px",
  maxWidth: "70%",
  alignSelf: isUser ? "flex-end" : "flex-start",
  backgroundColor: isUser ? "#1976D2" : "#E3F2FD",
  color: isUser ? "#fff" : "#000",
  borderRadius: "10px",
}));
const Dashboard = () => {
  const {
    transcript,
    listening,
    resetTranscript,
  } = useSpeechRecognition();

  const token = JSON.parse(localStorage.getItem("access_token"));
  const patient_id = JSON.parse(localStorage.getItem("patient_id"));
  const [query, setQuery] = useState("");
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (!listening && transcript.trim()) {
      sendMessage(new Event("submit"));
    }
  }, [listening]);
  const sendMessage = async (e) => {
    if (!query.trim() && !transcript.trim()) return; // Prevent empty submissions

    const userInput = transcript.trim() ? transcript : query;
    setQuery(""); // Clear the text input
    resetTranscript(); // Reset voice input

    setMessages([...messages, { role: "user", content: userInput }]);

    try {
      // const response = await axios.post(`${API_URL}query?query=${input}&access_token=${TOKEN}&session_id=12`);
      const response = await axios.post(
        `${process.env.REACT_APP_QUERY_URL}?query=${userInput}&access_token=${token}&session_id=26&patient_id=${patient_id}&identity=CLARA`
      );
      // console.log("resp", response?.data?.conversation);
      if (response?.data) {
        const filteredMessages = response.data?.conversation.filter(
          (msg) => msg.role !== "system" && msg.role !== "tool"
        );
        // console.log("filteredMessages", filteredMessages);
        setMessages(filteredMessages);
      }
    } catch (error) {
      console.error("Error:", error);
      setMessages((prev) => [
        ...prev,
        { role: "bot", content: "Error fetching response." },
      ]);
    }
  };

  //function to Parse the response

  const cleanHTML = (text) => {
    if (!text) return "No response available.";
    return parse(text.replace(/```html|```/g, "").trim());
  };

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: "0",
        top: "0",
        width: "100%",
        height: "100%",
      }}
    >
      <Box display="flex" bgcolor="#FFFFFF" height={"100%"}>
        {/* Sidebar */}
        <Box
          bgcolor="white"
          display="flex"
          flexDirection="column"
          alignItems="center"
          borderRight={1}
          borderColor="#E2E8F0"
          className="sidebar"
        >
          <MaryIcon alt="User" />
          <HomeIcon />
          <ProfileIcon />
          {/* {[Home, Settings].map((Icon, index) => (
          <IconButton key={index} color="default">
            <Icon />
          </IconButton>
        ))} */}
        </Box>

        {/* Main Content */}
        <Box
          flex={1}
          display="flex"
          flexDirection="column"
          py={1}
          sx={{ backgroundColor: "#F8FAFC" }}
        >
          <AppBar
            position="static"
            color="default"
            elevation={0}
            sx={{
              borderBottom: 1,
              borderColor: "#e0e0e0",
              backgroundColor: "#F8FAFC",
            }}
          >
            <Toolbar>
              <Typography
                variant="lSize"
                className="font-w-800 black-color-4"
                sx={{ flexGrow: 1 }}
              >
                MARY
              </Typography>
            </Toolbar>
          </AppBar>

          {!patient_id && (
            <Box
              flex={1}
              display="flex"
              flexDirection="column"
              alignItems="center"
              my={3}
              //   justifyContent="center"
              textAlign="center"
            >
              <Typography variant="mSize" className="font-w-500 black-color">
                Speaking to Mary
              </Typography>
              <Typography
                variant="lSize"
                className="font-w-400 black-color-3"
                my={2}
              >
                Go ahead, I'm Listening
              </Typography>
              <Typography
                variant="lSize"
                className="font-w-400 black-color-3"
                my={2}
              >
                Search Your Patient
              </Typography>
              <Box className="wave">
                <WaveIcon
                  alt="Listening animation"
                  style={{ marginTop: 24, width: "100%", height: "100%" }}
                />
              </Box>
            </Box>
          )}

          {patient_id && (
            <MessagesContainer className="msg-container">
              {messages.map((msg, index) => (
                <MessageBubble key={index} isUser={msg.role === "user"}>
                  {cleanHTML(msg.content)}
                </MessageBubble>
              ))}
            </MessagesContainer>
          )}

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              my: "3",
             justifyContent:"space-evenly",
             width:'50%',
             margin:"auto",
             
            }}
          >
            <Typography variant="mSize" className="font-w-400 black-color">
              {transcript}
            </Typography>
            {transcript && <CloseIcon alt="stop" onClick={resetTranscript} cursor="pointer"/>}
          </Box>
          <Box
            component="form"
            elevation={0}
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
            }}
            className="message-box"
            onSubmit={(e) => {
              e.preventDefault(); // ✅ Prevents default form submission
              sendMessage();
            }}
          >
            <TextField
              sx={{
                flex: 1,
                bgcolor: "#f5f5f5",
                p: 1,
                px: 2,
              }}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Send a message"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {" "}
                    <IconButton onClick={sendMessage} sx={{ "&:hover": {
      backgroundColor: "transparent" // Removes background color change
    }}}>
                      <SubmitIcon type="submit" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
            />
            <IconButton
              onClick={() =>
                SpeechRecognition.startListening({ continuous: false })
              }
            >
              {!listening && <MicIcon />}
              {listening && <MicOnIcon />}
            </IconButton>
          </Box>
        </Box>

        {/* Recent Chats */}
        <Box
          width={360}
          bgcolor="white"
          display="flex"
          flexDirection="column"
          borderLeft={1}
          borderColor="#e0e0e0"
        >
          {/* <IconButton color="default">
              <Settings />
            </IconButton> */}
          <Box
            borderBottom={1}
            borderColor="#e0e0e0"
            bgcolor="white"
            display="flex"
            flexDirection="row"
            alignItems="center"
            p={2}
          >
            <Avatar src="https://placehold.co/40x40" alt="User" />
            <Typography
              variant="xxsSize"
              className="font-w-700 black-color-4"
              ml={2}
            >
              X_AE_A-13
            </Typography>
          </Box>

          <Accordion className="recentChats">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography
                component="span"
                variant="xsSize"
                className="font-w-700 black-color-4 chat-heading"
              >
                {" "}
                Recent Chats
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                {[
                  "Viewed Medical History",
                  "Booked Appointment",
                  "Updated Contact Info",
                  "Checked Prescription",
                  // "Viewed Lab Reports",
                  // "Cancelled Appointment",
                  // "Printed Patient Report",
                ].map((text, index) => (
                  <ListItem
                    key={index}
                    // sx={{
                    //   "&:hover": {
                    //     backgroundColor: "#f5f5f5", // Light gray background on hover
                    //     cursor: "pointer", // Changes cursor to pointer
                    //   },
                    // }}
                  >
                    <ListItemText
                      primary={text}
                      secondary={text !== "Booked Appointment" && "2m ago"}
                    />
                    {text === "Booked Appointment" && (
                      <Box display="flex">
                        <IconButton size="small">
                          <PencilIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small">
                          <TrashIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                  </ListItem>
                ))}
              </List>
            </AccordionDetails>
          </Accordion>

          {/* <Typography variant="h6" p={2}>
          Recent Chats
        </Typography> */}
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
